import PropTypes from 'prop-types'
import { createRef, PureComponent } from 'react'
import { Form } from 'semantic-ui-react'

import { ServerResponseSchema } from 'app'
import { SimpleButton } from 'ui'

import ListOptionSchema from '../../../schemas/ListOptionSchema'
import PlayerBioSecurityForm from '../PlayerBioSecurityForm'

const isNIN = (val) =>
  `${val}`.replaceAll(/([^0-9]+)/gi, '').length !== `${val}`.length || `${val}`.replaceAll(/([^0-9]+)/gi, '').length < 5
    ? 'Incluye un número de indentificación sin espacios o letras'
    : null

class AgentBioSecurityForm extends PureComponent {
  el = createRef()

  state = {
    fields: {
      nin: {
        error: null,
        getError: isNIN,
        value: '',
      },
    },
  }

  onChange = (_, { name, value }) =>
    this.setState(({ fields }) => ({
      fields: {
        ...fields,
        [name]: {
          ...fields[name],
          error: null,
          value,
        },
      },
    }))

  onKeyPress = ({ which }) => {
    if (which === 13) {
      this.onValidateNIN()
    }
  }

  onSave = (data, message) => this.props.onSave({ ...data, role: 'AGENT' }, message)

  onValidateNIN = () => {
    const fields = { ...this.state.fields }
    let errors = 0

    Object.keys(fields).forEach((field) => {
      fields[field].error = fields[field].getError(fields[field].value)
      errors += !!fields[field].error
    })

    if (errors) {
      this.setState({ fields }, () => this.el?.current?.querySelector('.field.error input')?.focus())
    } else {
      const data = {
        role: 'AGENT',
      }
      Object.keys(fields).forEach((key) => {
        data[key] = fields[key].value
      })
      this.props.onValidateNIN(data)
    }
  }

  render() {
    const { className, error, positions, teams, values } = this.props
    const { fields } = this.state

    return (
      <div className={className} ref={this.el}>
        <Form>
          <Form.Group>
            <Form.Input
              error={fields.nin.error}
              label="Número NUIP del jugador al que representas"
              name="nin"
              onChange={this.onChange}
              onKeyPress={this.onKeyPress}
              required
              type="text"
              value={fields.nin.value}
            />
          </Form.Group>
          <SimpleButton onClick={this.onValidateNIN} primary value="Buscar jugador" />
        </Form>
        <br />
        {!error && !!fields.nin.value && !!values?.searchNIN?.data?.[0] && (
          <PlayerBioSecurityForm
            asAgent
            onSave={this.onSave}
            positions={positions}
            teams={teams}
            values={{
              ...values.searchNIN.data[0].profile,
              ...values.searchNIN.data[0].form,
              ...values.searchNIN.data[0].line_up,
            }}
          />
        )}
      </div>
    )
  }
}

AgentBioSecurityForm.propTypes = {
  onSave: PropTypes.func.isRequired,
  onValidateNIN: PropTypes.func.isRequired,
  positions: PropTypes.arrayOf(ListOptionSchema).isRequired,
  teams: PropTypes.arrayOf(ListOptionSchema).isRequired,

  className: PropTypes.string,
  error: PropTypes.shape({}),
  values: PropTypes.shape({
    searchNIN: ServerResponseSchema,
  }),
}

AgentBioSecurityForm.defaultProps = {
  className: '',
  error: {},
  values: {},
}

export default AgentBioSecurityForm
